import type { IconData } from '@stacksjs/iconify-core'

export const invisible1Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.914 1.086a2 2 0 1 0-2.828 2.828l43 43a2 2 0 1 0 2.828-2.828l-7.803-7.803c3.407-2.85 5.956-6.651 7.204-10.99a4.7 4.7 0 0 0-.001-2.601C43.574 13.195 34.6 6.273 24 6.273a23.6 23.6 0 0 0-11.779 3.121zm15.99 15.989l11.022 11.023a8.045 8.045 0 0 0-11.023-11.023m-10.48-1.058a2 2 0 1 0-2.917-2.737a22.8 22.8 0 0 0-5.305 9.29a5.2 5.2 0 0 0 .002 2.878c2.802 9.715 11.973 16.78 22.793 16.78c3.095 0 6.058-.578 8.775-1.633a2 2 0 1 0-1.447-3.728a20.2 20.2 0 0 1-7.328 1.361c-9.064 0-16.65-5.911-18.95-13.888a1.2 1.2 0 0 1 0-.664a18.8 18.8 0 0 1 4.377-7.659\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default invisible1Remix
